// extracted by mini-css-extract-plugin
export default {"title":"Catalogue_title__ZgTdC","title2":"Catalogue_title2__1puyI","header_links":"Catalogue_header_links__vypRu","catalogue":"Catalogue_catalogue__xH2TS"};